export enum Tier {
  Free = 'free',
  Paid = 'paid',
  Trial = 'trial',
}

export enum Role {
  BasicAccess = 'BasicAccessRole',
  FullAccess = 'FullAccessRole',
}
